import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseButton, useT } from '@repo/common';
import AdminSidebarItem from './AdminSidebarItem';

import { ReactComponent as PlusIcon } from '@repo/common/assets/icons/20px/icon_20px_plus_outline.svg';
import { ReactComponent as FileDraftIcon } from '@repo/common/assets/icons/16px/icon_16px_file-draft_outline.svg';
import { ReactComponent as VisibleIcon } from '@repo/common/assets/icons/16px/icon_16px_visible_outline.svg';
import { ReactComponent as InvisibleIcon } from '@repo/common/assets/icons/16px/icon_16px_invisible-close_outline.svg';
import { ReactComponent as FolderIcon } from '@repo/common/assets/icons/16px/icon_16px_folder_outline.svg';
import { ReactComponent as TrashIcon } from '@repo/common/assets/icons/16px/icon_16px_delete_outline.svg';
import { ReactComponent as DraftIcon } from '@repo/common/assets/icons/16px/icon_16px_file-new-empty_outline.svg';
import { ReactComponent as ClockAlarmIcon } from '@repo/common/assets/icons/16px/icon_16px_clock-alarm_outline.svg';

export const MENU_ITEMS = [
  {
    id: 'all',
    label: ['All Jobs', '전체 공고'],
    icon: <FileDraftIcon />,
    count: 0,
    status: 'default',
  },
  {
    id: 'active',
    label: ['Active Jobs', '게시 중인 공고'],
    icon: <VisibleIcon />,
    count: 0,
    status: 'active',
  },
  {
    id: 'hidden',
    label: ['Hidden Jobs', '숨긴 공고'],
    icon: <InvisibleIcon />,
    count: 0,
    status: 'default',
  },
  {
    id: 'drafts',
    label: ['Drafts', '임시저장'],
    icon: <DraftIcon />,
    count: 0,
    status: 'default',
  },
  {
    id: 'archive',
    label: ['Archive', '보관함'],
    icon: <FolderIcon />,
    count: null,
    status: 'disabled',
  },
  {
    id: 'closed',
    label: ['Closed Jobs', '마감된 공고'],
    icon: <ClockAlarmIcon />,
    count: 0,
    status: 'default',
  },
  {
    id: 'trash',
    label: ['Trash', '휴지통'],
    icon: <TrashIcon />,
    count: 0,
    status: 'default',
  },
];

const AdminSidebar = ({
  activeStatus,
  onChangeStatus,
  counts = {},
  hideArchive = false,
  showAllJobs = false,
  // 'drawer': 모바일 좌측 드로어용 — 타이틀 없이 버튼 좌우 16px, 메뉴는 우측 16px 여백
  variant = 'default',
}) => {
  const isDrawer = variant === 'drawer';
  const t = useT();
  const navigate = useNavigate();

  const menuItems = MENU_ITEMS.filter(
    (item) =>
      (!hideArchive || item.id !== 'archive') &&
      (showAllJobs || item.id !== 'all'),
  ).map((item) => ({
    ...item,
    count:
      item.count === null
        ? null
        : counts[item.id] === undefined
          ? item.count
          : counts[item.id],
  }));

  return (
    <div className='flex flex-col items-start w-full gap-6'>
      {!isDrawer && (
        <h1 className='px-3 text-[32px] leading-[1.2] font-medium text-text-primary'>{t('Job Postings', '채용 공고 관리')}</h1>
      )}
      <div className={`w-full ${isDrawer ? 'px-4' : ''}`}>
        <BaseButton
          icon={<PlusIcon />}
          iconPosition='after'
          width='100%'
          size='xl'
          onClick={() => navigate('/jobs/admin/new')}
        >
          {t('Create job', '공고 등록')}
        </BaseButton>
      </div>
      <div className={`w-full ${isDrawer ? 'pr-4' : ''}`}>
        <nav className='flex flex-col'>
          {menuItems.map((item) => {
            const isActive = activeStatus === item.id;
            const status =
              item.status === 'disabled'
                ? 'disabled'
                : isActive
                ? 'active'
                : 'default';

            return (
              <AdminSidebarItem
                key={item.id}
                icon={item.icon}
                label={t(item.label[0], item.label[1])}
                count={item.count}
                status={status}
                onClick={() => {
                  if (item.status !== 'disabled') {
                    onChangeStatus(item.id);
                  }
                }}
              />
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default AdminSidebar;
